
import { Vue, Component, Prop } from "vue-property-decorator";
import CardChipAvatar from "@/components/legacy/card/card-chip-avatar.vue";

type Item = {
  id?: string;
  avatar?: string;
  name?: string;
};

@Component({
  components: {
    CardChipAvatar,
  },
})
export default class CardChips extends Vue {
  @Prop(Array) readonly items!: Item[];
  @Prop(String) readonly type!: string;
  @Prop(String) readonly heading!: string;
  @Prop(String) readonly path!: string;
  @Prop(Boolean) readonly linked!: boolean;
  @Prop(Boolean) readonly avatar!: boolean;
  @Prop(Boolean) readonly showAll!: boolean;

  limit: number = 3;

  redirect(id: string) {
    if (this.linked) {
      this.$router.push(`${this.path}/${id}`).catch(() => {});
    }
  }

  get firstThreeItems(): Item[] {
    return this.showAll ? this.items : this.items.slice(0, this.limit);
  }

  get itemsExist(): boolean {
    return this.items && this.items.length > 0;
  }

  get itemsMoreThanLimit(): boolean {
    return this.items.length > this.limit;
  }

  expand(): void {
    this.limit = this.items.length;
  }

  collapse(): void {
    this.limit = 3;
  }
}
